<template>
	<div>
		<ValidationObserver ref="formModalValidate">
			<b-row>
				<b-col cols="12" md="6" lg="4">
					<ValidationProvider name="semester_id" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="formData.semester_id" :validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="6" lg="4">
					<ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('program')">
							<program-selectbox v-model="formData.program_code" :faculty_code="34" :validate-error="errors[0]" />
						</b-form-group>
					</ValidationProvider>
				</b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="quota" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('quota')">
                            <b-form-input type="text" v-model="formData.quota" :validate-error="errors[0]" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
			</b-row>
			<div class="d-flex justify-content-center mt-2">
				<b-button variant="primary" @click="updateForm" :disabled="formLoading">
					{{ $t('save') }}
				</b-button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
// Components
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox"

// Services
import GraduateApplicationQuotasService from "@/services/GraduateApplicationQuotasService";

// Other
import { ValidationProvider, ValidationObserver } from "vee-validate"
import EvaluationsSelectbox from "@/components/interactive-fields/EvaluationsSelectbox.vue";

export default {
	components: {
		ProgramSelectbox,
		ValidationProvider,
		ValidationObserver,
	},
	props: {
		formId: {
			type: Number,
		}
	},
	data() {
		return {
			formData: {
                semester_id: null,
                program_code: null,
                quota: null
			},
			coordinatorValue: {},
			formLoading: false,
		}
	},
	watch: {
		formId: function (val) {
			this.get(val)
		}
	},
	async created() {
		await this.get(this.formId)
	},
	methods: {
		get(id) {
			GraduateApplicationQuotasService.get(id)
				.then(response => {
					let data = response.data.data;
					this.formData = {
                        semester_id: data.semester_id,
                        program_code: data.program_code,
                        quota: data.quota,

					}
				})
				.catch(e => {
					this.showErrors(e)
				})
		},

		async updateForm() {
			if (this.checkPermission('graduateapplicationquota_update')) {
				const isValid = await this.$refs.formModalValidate.validate();
				if (isValid && this.formId) {
					this.formLoading = true

					GraduateApplicationQuotasService.update(this.formId, this.formData)
						.then(response => {
							this.$emit('updateFormSuccess', true);
							this.$toast.success(this.$t(response.data.message));
						})
						.catch(e => {
							this.showErrors(e, this.$refs.formModalValidate);
						})
						.finally(() => {
							this.formLoading = false
						})
				}
			} else {
				this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
			}
		}
	}
}
</script>
